import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import TUIRoomCore, { TRTCVideoResolution } from '../../tui-room-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoProfile',
  setup(__props) {

const videoProfile = ref('720P');

const videoProfileList = [
  { label: '流畅（360P，15FPS）', value: '360P' },
  { label: '标清（540P，15FPS）', value: '540P' },
  { label: '高清（720P，30FPS）', value: '720P' },
  { label: '超清（1080P，30FPS）', value: '1080P' }];

const videoProfileMap: Record<string, any> = {
  '360P': { videoResolution: TRTCVideoResolution.TRTCVideoResolution_640_360, fps: 15, bitrate: 800 },
  '540P': { videoResolution: TRTCVideoResolution.TRTCVideoResolution_960_540, fps: 15, bitrate: 900 },
  '720P': { videoResolution: TRTCVideoResolution.TRTCVideoResolution_1280_720, fps: 15, bitrate: 1200 },
  '1080P': { videoResolution: TRTCVideoResolution.TRTCVideoResolution_1920_1080, fps: 30, bitrate: 1200 },
};

watch(videoProfile, (val: string) => {
  const currentVideoProfileObj = videoProfileMap[val];
  TUIRoomCore.setVideoEncoderParam(currentVideoProfileObj);
});


return { __sfc: true,videoProfile, videoProfileList, videoProfileMap }
}

})